import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL, DEFAULT_OG_IMAGE } from "../../lib/seoConfig";

/**
 * Reusable per-page SEO head component (title, description, canonical,
 * robots, Open Graph, Twitter card, JSON-LD). Every public marketing page
 * should render exactly one of these near the top of its JSX.
 */
export function SEO({
  title,
  description,
  path,
  robots = "index, follow",
  ogImage,
  ogType = "website",
  jsonLd,
}) {
  const pathname = path || (typeof window !== "undefined" ? window.location.pathname : "/");
  const canonical = `${SITE_URL}${pathname}`;
  const image = ogImage ? `${SITE_URL}${ogImage}` : `${SITE_URL}${DEFAULT_OG_IMAGE}`;
  const schemas = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={robots} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
